<script setup>
import { URL_SUBSCRIPTION_LANDING_PAGE } from '@tools/routes/routes';
import { computed } from 'vue';
import useInvoiceModalStore from '@organisms/ubiq-administration/store/invoiceModal';
import { trans } from '@elements/translation';
import { FRONT_STRIPE_STATUS } from '../constants/constants';
import { EVENT_SLIDERS } from '../general/event-constants';
import CardEmptyTable from '../general/CardEmptyTable.vue';
import { getAccountStatus } from '../helper/StripeHelper';
import EncourageStripeBlock from './EncourageStripeBlock.vue';

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

const { setModal } = useInvoiceModalStore();
const statusType = computed(() => getAccountStatus(props.status));

const createStripeAccount = () => {
  setModal({
    modalTitle: trans('gestion.subscription.slider.create_account.title'),
    modalComponentName: EVENT_SLIDERS.CREATE_STRIPE_ACCOUNT,
    shouldOpenModal: true,
  });
};
</script>

<template>
  <div>
    <div
      v-if="statusType === FRONT_STRIPE_STATUS.EMPTY || statusType === FRONT_STRIPE_STATUS.ACTION_REQUIRED"
      class="encourage-stripe"
    >
      <div class="encourage-stripe__action encourage-stripe-action">
        <span class="encourage-stripe-action__title">
          {{ trans('gestion.subscription.encourage.title') }}
        </span>
        <button
          v-if="statusType === FRONT_STRIPE_STATUS.EMPTY"
          class="btn btn--primary btn--small encourage-stripe-action__button encourage-stripe-action__button--empty"
          @click="createStripeAccount"
        >
          {{ trans('gestion.subscription.encourage.start_billing') }}
        </button>
        <button
          v-if="statusType === FRONT_STRIPE_STATUS.ACTION_REQUIRED"
          class="btn btn--primary btn--small encourage-stripe-action__button encourage-stripe-action__button--pending"
          @click="createStripeAccount"
        >
          {{ trans('gestion.subscription.encourage.resume_setup') }}
        </button>
      </div>
      <div class="encourage-stripe__explanation encourage-stripe-explanation">
        <EncourageStripeBlock
          :title="trans('gestion.subscription.encourage.time.title')"
          :description="trans('gestion.subscription.encourage.time.description')"
          icon-class="time"
        />
        <EncourageStripeBlock
          :title="trans('gestion.subscription.encourage.control.title')"
          :description="trans('gestion.subscription.encourage.control.description')"
          icon-class="control"
        />
        <EncourageStripeBlock
          :title="trans('gestion.subscription.encourage.cost.title')"
          :description="trans('gestion.subscription.encourage.cost.description')"
          icon-class="help"
          :link="URL_SUBSCRIPTION_LANDING_PAGE"
          :link-title="trans('gestion.subscription.encourage.cost.link')"
        />
      </div>
    </div>
    <CardEmptyTable
      v-if="statusType === FRONT_STRIPE_STATUS.PENDING"
      font-color-logo="green"
      logo="ph_check-circle-fill_green"
      :title="trans('gestion.subscription.account.pending.title')"
      :subtitle="trans('gestion.subscription.account.pending.description')"
    />
    <template v-else-if="statusType === FRONT_STRIPE_STATUS.READY">
      <slot name="ready" />
    </template>
  </div>
</template>
